import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const GAME_UUID = "607888e1-133e-40ce-b5c6-e00be24c5494";

const chumbiValleyQuestQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-wishlist-added`,
    ruleId: `${GAME_UUID}-wishlist`,
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch the trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "iframe/embed",
    videoUrl: "https://www.youtube.com/embed/6jmkiBnS5hA",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-trailer-event`,
    ruleId: `${GAME_UUID}-trailer`,
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    linkUrl: "http://discord.gg/chumbi",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-join-discord-event`,
    ruleId: `${GAME_UUID}-join-discord`,
  },
  {
    type: "link",
    key: "telegram-v2",
    icon: "Telegram",
    label: "Join Telegram channel",
    caption: "Join our massively growing community",
    linkUrl: "https://t.me/chumbivalley01",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-chumbi-telegram-validation-completed`,
    ruleId: "chumbi-telegram-validation",
  },
];

const chumbiValleyQuestQuestsLvl2: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Check out the store",
    caption: "The official online store for Chumbi!",
    linkUrl: "https://chumbi.shop/en-aud/",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: `${GAME_UUID}-website-store-event`,
    ruleId: `${GAME_UUID}-website-store`,
    waitTimeInHrs: 24,
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow Chumbi Valley on X",
    caption: "Don't miss a tweet",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    linkUrl: "https://x.com/ChumbiValley",
    eventId: `${GAME_UUID}-follow-x-event`,
    ruleId: `${GAME_UUID}-follow-x`,
  },
];

export const chumbiValleySocialEngagementQuests: Quest[] = [
  {
    type: "custom",
    key: "social-engagement",
    icon: "SupportChat",
    label: "Post a message and engage in the Telegram channel daily",
    caption: "Earn gems everyday",
    increase: 10,
    badgeIcon: "ImxRewards",
    recurring: true,
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "607888e1-133e-40ce-b5c6-e00be24c5494-chumbivalley-telegram-social-engagement-completed",
    ruleId: "chumbivalley-telegram-social-engagement",
  },
];

export const chumbiValleyQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      title: "Learn and connect",
      description: "Level 1 Supporter",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +35 <icon> Gems",
    totalGemsGranted: 35,
    hideOnCompletion: true,
    lockedUntilPrevious: false,
    quests: chumbiValleyQuestQuestsLvl1,
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Dive deeper",
      description: "Level 2 Believer",
    },
    nextQuest: {
      url: "/games/overknights",
      title: "Thanks for getting involved",
      label: "Want more? Check out Overknights",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +15 <icon> Gems",
    totalGemsGranted: 15,
    hideOnCompletion: false,
    lockedUntilPrevious: false,
    quests: chumbiValleyQuestQuestsLvl2,
  },
  {
    key: "social-engagement",
    header: {
      image: "",
      description: "",
      title: "Social Engagement",
    },
    totalGemsGranted: 10,
    quests: chumbiValleySocialEngagementQuests,
    hideOnCompletion: false,
    lockedUntilPrevious: false,
  },
];
